/* eslint-disable complexity */
export default class TaxononyHeader {

    constructor() {
        this.activeButton();
    }

    activeButton(){
        // Desktop
        this.url = Array.prototype.slice.call(document.querySelectorAll('.taxonomy-menu-item a'));
        const pathName = location.pathname;
        const queryString = location.search.split('&');
        const currentPathname = pathName.lastIndexOf('/') === pathName.length - 1 ? pathName.substr(0, pathName.length - 1) + queryString[0] : pathName + queryString[0];
        let isSelected = false;
        if(queryString.indexOf('trendingTags=true') === -1) {
            this.url.forEach(function(value) {
                const taxonomyUrl = value.getAttribute('href') + queryString[0];
                if (taxonomyUrl  === currentPathname){
                    if (window.addClass){
                        window.addClass(value, 'active');
                    }
                    isSelected = true;
                }
            });
        }
        this.option = Array.prototype.slice.call(document.querySelectorAll('.dropdown-element__select option'));
        this.option.forEach(function(option) {
            const taxonomyUrl = option.value + queryString[0];
            if (taxonomyUrl === currentPathname){
                option.setAttribute('selected', 'selected');
                isSelected = true;
            }
        });
        if (!isSelected && window.addClass && queryString.indexOf('trendingTags=true') === -1) {
            window.addClass(Array.prototype.slice.call(document.querySelectorAll('.taxonomy-menu-item a'))[0], 'active');
            Array.prototype.slice.call(document.querySelectorAll('.dropdown-element__select option'))[0].setAttribute('selected', 'selected');
        }
        // Mobile
        const selectTaxonomyValue = document.querySelector('.dropdown-element__select');
        selectTaxonomyValue.addEventListener('change', () => {
            window.location = selectTaxonomyValue.options[selectTaxonomyValue.selectedIndex].value;
        });
    }

}





// WEBPACK FOOTER //
// /src/pages/main/components/taxonomyHeader/index.js